import { Injectable } from '@angular/core';

import { InstancesManagerService } from '@app/services/instances-manager.service';
import { AuthenticateService } from '@app/origami-api/services/authenticate/authenticate.service';

@Injectable()
export class AppService {
  public static readonly NO_BEFOREUNLOAD_COOKIE = 'ti-nobeforeunload';
  public static readonly NO_CAS_COOKIE = 'ti-nocas';
  private readonly beforeUnloadHandler;
  private readonly unloadHandler;

  public allowNextNavigationOut: boolean = false;

  constructor(
    private readonly instancesManagerService: InstancesManagerService,
    private readonly authenticateService: AuthenticateService,
  ) {
    this.beforeUnloadHandler = this.beforeUnload.bind(this);
    this.unloadHandler = this.unload.bind(this);
  }

  public static getCookie(name: string) {
    let ca: string[] = document.cookie.split(';');
    let caLen: number = ca.length;
    let cookieName = `${name}=`;
    let c: string;

    for (let i: number = 0; i < caLen; i += 1) {
      c = ca[i].replace(/^\s+/g, '');
      if (c.indexOf(cookieName) === 0) {
        return c.substring(cookieName.length, c.length);
      }
    }
    return '';
  }

  public init() {
    this.instancesManagerService.start();
    this.addBeforeUnloadListener();
    this.addUnloadListener();
  }

  addBeforeUnloadListener() {
    window.addEventListener('beforeunload', this.beforeUnloadHandler);
  }

  removeBeforeUnloadListener() {
    window.removeEventListener('beforeunload', this.beforeUnloadHandler);
  }

  addUnloadListener() {
    window.addEventListener('unload', this.unloadHandler);
  }

  beforeUnload(event) {
    const href = event.target.location.href;

    const nonPreventPaths = [
      'localhost',
      'auth/password-reset',
      'auth/session-expired',
      'auth/registration',
      'auth/global-directory',
    ];

    const isNonPreventPath = nonPreventPaths.some((path) => href.indexOf(path) !== -1);
    const cookie = AppService.getCookie(AppService.NO_BEFOREUNLOAD_COOKIE);

    if (!isNonPreventPath && !cookie && !this.allowNextNavigationOut) {
      (event || window.event).returnValue = false;
    }

    this.allowNextNavigationOut = false;
  }

  unload() {
    this.instancesManagerService.unregisterInstance();

    if (this.instancesManagerService.noMoreInstances()) {
      this.authenticateService.logOffByTimeout();
    }
  }
}
